import { apiPrefixes } from '@/api/apiPrefixes'
import { ResultType, httpWithCookie, toLogin } from '@/utils'
import { RecruitMember, RecruitParam, TNcConf } from '@/interfaces/recruitModel'
import { DataWithId } from '@/interfaces/baseconfig'

const api = {
  // 候选人列表 初筛列表/用人部门筛选
  queryRecruitList: `${apiPrefixes.ehrapi}/api/rkhy/recruitManage/queryList.do`
}

const queryRecruitList = async (
  params: RecruitParam,
  requestid: string
): Promise<DataWithId<RecruitMember[]>> => {
  const result = await httpWithCookie.post<
    any,
    ResultType<{ list: RecruitMember[] }>
  >(api.queryRecruitList, params)

  const { code, data } = result
  if (code === '1') {
    return { data: data?.list || [], requestid: requestid }
  } else if (+code == 1024) {
    toLogin()
    return { requestid: requestid }
  } else {
    return { requestid: requestid }
  }
}

export const recruit = {
  queryRecruitList
}
